import React from 'react';
import OrderForm from '../OrderForm/OrderForm';

const OrderService = () => {
    return (
        <div>

            <OrderForm />

        </div>
    );
};

export default OrderService;